// extracted by mini-css-extract-plugin
export default {"title":"team-module--title--9bEh5","teamTitle":"team-module--teamTitle--COGUd","fire":"team-module--fire--2pTrO"};